enum Journeys {
  LEARN_MORE = "LEARN_MORE",
  READY_FOR_NEXT_STEP = "READY_FOR_NEXT_STEP",
  TAKING_ACTION = "TAKING_ACTION",
  PREGNANCY = "PREGNANCY"
}

export default Journeys
